import { PROMO_FEATURE_FLAG } from '@mc/promo-utils'

export const FORCE_BUCKETING_COOKIE = 'mc_gb_force'

// Set to `1` to put the visitor in no experiment (GrowthBook QA mode).
// getGrowthBookFlags then ignores FORCE_BUCKETING_COOKIE and `exp_` params.
export const FORCE_ALL_COOKIE = 'mc_gb_enable_qa_mode'

// you can force an experiment variation with a browser URL parameter
// simply add the URL param `?exp_{flag key}={desired bucket name}`
export const FORCE_FLAG_PREFIX = 'exp_'
// force variations will only work for flags which have correctly configured variations
// e.g. `{ bucketName: "variant_1" }`

const FORCE_EXCLUDED_EXPERIMENTS = [PROMO_FEATURE_FLAG]

const FLAG_BUCKET_DELIMITER = ':'
const FORCE_VARIATION_DELIMITER = '/'

// GrowthBook flags or buckets should not have any unexpected characters
const validString = /^[A-Za-z0-9_-]+$/
export const deserializeBucketMap = (cookieValue: string | undefined) => {
  const bucketMap = new Map<string, string>()
  cookieValue?.split(FORCE_VARIATION_DELIMITER)?.forEach((forceBucketing) => {
    const [flagName, forceBucket] = forceBucketing.split(FLAG_BUCKET_DELIMITER)
    if (validString.test(flagName) && validString.test(forceBucket)) {
      bucketMap.set(flagName, forceBucket)
    }
  })
  return bucketMap
}

export const isQaModeCookieSet = (cookieValue: string | undefined) =>
  cookieValue === '1'

export const serializeBucketMap = (bucketMap: Map<string, string>) =>
  [...bucketMap.entries()]
    .map(([flag, bucket]) => `${flag}${FLAG_BUCKET_DELIMITER}${bucket}`)
    .join(FORCE_VARIATION_DELIMITER)

export const canForceExperiment = (paramKey: string) =>
  !FORCE_EXCLUDED_EXPERIMENTS.some(
    (key) => `${FORCE_FLAG_PREFIX}${key}` === paramKey,
  )
